import React, { useState } from 'react';
import { useWorkshops } from '../WorkshopContext';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css'

const Navbar = () => {
    const [isActive, setIsActive] = useState(false);
    const [isDropDownActive, setIsDropDownActive] = useState(false);
    const { state, dispatch} = useWorkshops();
    const location = useLocation();
    const isComparisonPage = location.pathname.startsWith('/compare') || location.pathname.startsWith('/land-use-comparison');
    
    const handleWorkshopClick = (workshopId) => {      
      dispatch({ type: 'set_selected', payload: workshopId });      
    };

    const toggleNavbar = () => {
      setIsActive(!isActive);
    };
    
    const toggleDropDown = () => {
      setIsDropDownActive(!isDropDownActive);
    };

    let homeUrl = process.env.NODE_ENV === "development" ? "/" : "/benchmarks/stakeholder-insights-explorer/";
    
    return (
      <nav className="navbar is-fixed-top" role="navigation" aria-label="main navigation" style={{backgroundColor: 'var(--main-green)'}}>
        <div className="container">
          <div className="navbar-brand">            
            <a className="navbar-item" href={homeUrl}>
              <img src={process.env.PUBLIC_URL + '/logos/SHB_logo_main_mono.png'} height="60" alt="Logo"/>
            </a>
            <button 
                className={`navbar-burger burger ${isActive ? 'is-active' : ''}`} 
                aria-label="menu" 
                aria-expanded="false" 
                onClick={toggleNavbar} 
                style={{ background: 'none', border: 'none' }}
                >
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
            </button>
          </div>
          <div className={`navbar-menu ${isActive ? 'is-active' : ''}`}>
            <div className="navbar-end">              
                {!isComparisonPage && (
                  <>
                    <a className="navbar-item" href="#workshops">Compare regions</a>
                    <Link className="navbar-item" to="/land-use-comparison">Compare land uses</Link>
                    <a className="navbar-item" href="#takeaways">Key Messages</a>
                  </>                  
                )}                
                {isComparisonPage && (
                  <Link className="navbar-item" to="/">Back to Main Page</Link>
                )}
                <Link className="navbar-item" target="_blank" to="https://soilhealthbenchmarks.eu/">Benchmarks Site</Link>  
                {!isComparisonPage && (
                  <div className={`navbar-item ${state.selectedWorkshopId ? '' : 'is-hidden'}`}>
                    <div className='level'>
                      <div className='level-item mr-3'>
                        Selected workshop:
                      </div>
                      <div className='level-item'>
                        <div className={`dropdown ${isDropDownActive ? 'is-active' : ''}`}>
                          <div className="dropdown-trigger" onClick={toggleDropDown}>
                            <button className="button" aria-haspopup="true" aria-controls="dropdown-menu">
                              <span>{state.workshops[state.selectedWorkshopId-1]? `${state.selectedWorkshopId}. ${state.workshops[state.selectedWorkshopId-1].name} (${state.workshops[state.selectedWorkshopId-1].country_code})` : "/"}</span>                            
                              <span className="icon is-small">
                                <i className="fas fa-angle-down" aria-hidden="true"></i>
                              </span>
                            </button>
                          </div>
                          <div className="dropdown-menu" id="dropdown-menu" role="menu">
                            <div className="dropdown-content">
                              {state.workshops.map(workshop => (          
                                <a key={workshop.id} className={`dropdown-item ${state.selectedWorkshopId === workshop.id ? 'is-selected' : ''}`} data-workshop={workshop.id} onClick={() => {handleWorkshopClick(workshop.id); toggleDropDown()}}>
                                  {`${workshop.id}. ${workshop.name} (${workshop.country_code})`}
                                </a>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>  
                  </div>
                )}
            </div>
          </div>
        </div>
      </nav>
    );
  };

  export default Navbar;
  
